/**
 * This script ensures proper initialization of variant selections 
 * and product forms to fix issues with variant selection.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Helper function to ensure variant ID inputs and submit buttons are enabled
  function enableVariantInputs() {
    // Enable variant ID inputs
    const variantInputs = document.querySelectorAll('form[action="/cart/add"] input[name="id"]');
    variantInputs.forEach(input => {
      input.disabled = false;
    });
    
    // Enable submit buttons for variants that are available
    const productForms = document.querySelectorAll('form[action="/cart/add"]');
    productForms.forEach(form => {
      const idInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('.product-form__submit');
      
      if (idInput && submitButton && idInput.value) {
        // Remove disabled attribute from the button
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
        
        // Update the button text to show "Add to Bag"
        const buttonTextSpan = submitButton.querySelector('span');
        if (buttonTextSpan) {
          buttonTextSpan.textContent = window.theme && window.theme.strings ? 
            window.theme.strings.addToBag || 'Add to Bag' : 
            'Add to Bag';
        }
      }
    });
  }

  // Function to synchronize variant ID to all cart forms in the same section
  function syncVariantIDsInSection(section, variantId) {
    if (!section || !variantId) return;
    
    // Find all add to cart forms in this section
    const forms = section.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = variantId;
        input.disabled = false;
        console.log('Synced variant ID to:', variantId, 'in form:', form);
      }
    });
  }

  // Enable all variant inputs initially
  enableVariantInputs();

  // Watch for changes on variant-radios and variant-selects
  document.addEventListener('change', function(event) {
    // Handle variant selection changes
    const variantElement = event.target.closest('variant-radios, variant-selects');
    if (variantElement) {
      // Enable inputs immediately
      enableVariantInputs();
      
      // Wait for variant selection logic to update
      setTimeout(() => {
        // Get the current variant ID from the variant selector
        if (variantElement.currentVariant && variantElement.currentVariant.id) {
          // Get the section that contains this variant selector
          const section = variantElement.closest('.shopify-section');
          if (section) {
            // Sync the variant ID to all forms in this section
            syncVariantIDsInSection(section, variantElement.currentVariant.id);
          }
        }
        
        // Make sure buttons are enabled
        enableVariantInputs();
      }, 50);
      
      // Check again after more time has passed
      setTimeout(enableVariantInputs, 300);
    }
  });

  // Intercept the native updateVariantInput method on variant selectors
  document.querySelectorAll('variant-radios, variant-selects').forEach(selector => {
    if (selector.updateVariantInput) {
      const originalUpdateVariantInput = selector.updateVariantInput;
      selector.updateVariantInput = function() {
        // Call the original method
        originalUpdateVariantInput.apply(this, arguments);
        
        // Also update any other forms in this section
        if (this.currentVariant && this.currentVariant.id) {
          const section = this.closest('.shopify-section');
          if (section) {
            syncVariantIDsInSection(section, this.currentVariant.id);
          }
        }
      };
    }
  });

  // Fix for any product form submissions
  document.addEventListener('submit', function(event) {
    if (event.target.matches('form[action="/cart/add"]')) {
      const idInput = event.target.querySelector('input[name="id"]');
      if (idInput) {
        // Make sure the input is enabled
        idInput.disabled = false;
        
        // Try to get the current variant from any variant selectors in the same section
        const section = event.target.closest('.shopify-section');
        if (section) {
          const variantSelectors = section.querySelectorAll('variant-radios, variant-selects');
          variantSelectors.forEach(selector => {
            if (selector.currentVariant && selector.currentVariant.id) {
              idInput.value = selector.currentVariant.id;
              console.log('Set variant ID on submit to:', selector.currentVariant.id);
            }
          });
        }
      }
    }
  }, true); // Use capture phase to run before other handlers
  
  // Add a MutationObserver to detect changes to the button state
  const productForms = document.querySelectorAll('form[action="/cart/add"]');
  productForms.forEach(form => {
    const submitButton = form.querySelector('.product-form__submit');
    if (submitButton) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'disabled' || mutation.attributeName === 'aria-disabled') {
            // If a variant is selected, we want to make sure the button is enabled
            const idInput = form.querySelector('input[name="id"]');
            if (idInput && idInput.value && !isOutOfStock(form)) {
              submitButton.removeAttribute('disabled');
              submitButton.removeAttribute('aria-disabled');
            }
          }
        });
      });
      
      observer.observe(submitButton, { attributes: true });
    }
  });
  
  // Helper function to check if the product is out of stock
  function isOutOfStock(form) {
    // Check for out of stock message or class
    const outOfStockElement = form.querySelector('.sold_out');
    if (outOfStockElement) return true;
    
    // Check product variant availability if possible
    // This depends on theme structure and may need adjustment
    return false;
  }
});
